// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Barlow', 'Barlow Fallback'","fontStyle":"normal"},"className":"__className_52f0b0"};